// @flow
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import type { Message } from 'types/message'
import type { Response } from 'types/response'

function useResponseInternal(
  response: ?Response,
  message: ?Message
): [
  boolean,
  {
    title: string,
    onClick: () => void,
  },
] {
  const history = useHistory()
  const showInternal = message?.message_type === 'internal'

  const finishInternalForm = React.useCallback(() => {
    if (!response?.uid && !response?.id) return

    history.push(
      `/internal-form/${response?.uid || response?.id}?messageCode=${
        message?.message_code || ''
      }`
    )
  }, [history, message?.message_code, response?.id, response?.uid])

  return [
    showInternal,
    {
      title: 'Edit Internal Form',
      onClick: finishInternalForm,
      disabled: response?.internal_locked,
    },
  ]
}

export default useResponseInternal
